export interface InlineParam {
    index: number;
    value: string;
}

export type InlineParamSegment =
    | { type: 'text'; value: string }
    | { type: 'param'; index: number; value: string };

/**
 * Parses a template string with {{N}} placeholders and inline params array
 * Returns an array of segments alternating between text and params
 * 
 * @param text - Template string with {{N}} placeholders
 * @param inlineParams - Array of {index, value} objects
 * @returns Array of segments for rendering
 */
export function parseInlineParams(text: string, inlineParams: InlineParam[]): InlineParamSegment[] {
    if(!text) return [];
    
    const regex = /\{\{(\d+)\}\}/g;
    const segments: InlineParamSegment[] = [];
    let lastIndex = 0;
    let match;

    while((match = regex.exec(text)) !== null) {
        // Add text segment before this placeholder
        if(match.index > lastIndex) {
            const textValue = text.slice(lastIndex, match.index);
            segments.push({type: 'text', value: textValue});
        }

        // Add param segment
        const paramIndex = parseInt(match[1], 10);
        const param = inlineParams.find(p => p.index === paramIndex);
        segments.push({
            type: 'param',
            index: paramIndex,
            value: param?.value || ''
        });

        lastIndex = match.index + match[0].length;
    }

    // Add remaining text after last placeholder
    if(lastIndex < text.length) {
        const textValue = text.slice(lastIndex);
        segments.push({type: 'text', value: textValue});
    }

    return segments;
}
